import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import { store } from '../../store'
import { DataSubscription } from '../../models/data-subscriptions/data-subscription'
import { dataSubscriptionsApi } from '../../services/api/data-subscriptions.api'
import { codePackagesApi } from '../../services/api/code-packages.api'

@Module({
    dynamic: true,
    namespaced: true,
    name: 'data-subscriptions',
    store,
})
class DataSubscriptionsStore extends VuexModule {
    private stateModel: {
        subscriptions: DataSubscription[],
        currentSubscription: DataSubscription | null
    } = { subscriptions: [], currentSubscription: null }

    get currentSubscription(): DataSubscription {
        return this.stateModel.currentSubscription!
    }

    get purchasedCodes(): string[] {
        return this.stateModel.currentSubscription?.limits?.codes ?? []
    }

    get purchasedStates(): string[] {
        return this.stateModel.currentSubscription?.limits?.states ?? []
    }

    @Mutation
    setSubscriptions(subs: DataSubscription[]) {
        this.stateModel.subscriptions = subs
    }

    @Mutation
    setPurchasedCodes(codes: string[]) {
        this.stateModel.currentSubscription!.limits!.codes = codes
    }

    @Action({ rawError: true })
    async setCurrentSubscriptions(sub: DataSubscription | null) {
        this.stateModel.currentSubscription = sub
        await this.getPurchasedCodes()
    }

    @Action({ rawError: true })
    async init() {
        await this.getSubscriptions()
        if (this.stateModel.subscriptions) {
            const selected = this.stateModel.subscriptions.find(x => x.selected === true)
            await this.setCurrentSubscriptions(selected ?? this.stateModel.subscriptions.first())
        } 
    }

    @Action({ rawError: true })
    async getSubscriptions() {
        let subs: DataSubscription[] = []
        try {
            const allSubs = await dataSubscriptionsApi.subscriptions()
            subs = allSubs.filter(x => x.active)
        } catch (err) {
            console.error(err)
        }
        this.setSubscriptions(subs)
        return subs
    }

    @Action({ rawError: true })
    async getPurchasedCodes() {
        const packages = this.purchasedCodes.filter(x => x.toLowerCase().startsWith('bundle_')
            || x.toLowerCase().startsWith('package_'))
        if (packages.length) {
            const packageCodes: string[] = []

            await Promise.all(packages.map(async pckg => {
                const codes = await codePackagesApi.get(pckg)
                if (codes) {
                    packageCodes.push(...codes)
                }
            }))

            const allCodes = this.purchasedCodes.filter(x => !x.toLowerCase().startsWith('bundle_')
                && !x.toLowerCase().startsWith('package_'))
            allCodes.push(...packageCodes)
            this.setPurchasedCodes(allCodes)
        }
    }
}

export const dataSubscriptionStore = getModule(DataSubscriptionsStore)
